module.exports = __webpack_public_path__ + "img/9788993094855.2a20a4cc.jpg";